import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const SendTvIcon: React.FC<OneColorIconProps> = ({ size = 25, color = 'black', className }) => {
  const colorHex = getHexColor(color)
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1525 54.6666V49.3333C9.68585 49.3333 8.43074 48.8115 7.38718 47.7679C6.34185 46.7226 5.81918 45.4666 5.81918 43.9999V14.6666C5.81918 13.1999 6.34185 11.9448 7.38718 10.9013C8.43074 9.85592 9.68585 9.33325 11.1525 9.33325H53.8192C55.2859 9.33325 56.5419 9.85592 57.5872 10.9013C58.6307 11.9448 59.1525 13.1999 59.1525 14.6666V43.9999C59.1525 45.4666 58.6307 46.7226 57.5872 47.7679C56.5419 48.8115 55.2859 49.3333 53.8192 49.3333V54.6666H51.1525L49.4192 49.3333H15.6192L13.8192 54.6666H11.1525ZM11.1525 43.9999H53.8192V14.6666H11.1525V43.9999Z"
        fill={colorHex}
      />
    </svg>
  )
}
